import React from 'react'
import Graph from './Graph'
import {NoExpenseComponentProps} from './expense-dashboard'

export const NoExpenseComponent: React.FC<NoExpenseComponentProps> = ({data, learnMoreUrl}) => {
    return (
        <>
            <div className="text-center my-5 text-2xl font-semibold">
                <p>
                    You don’t have stored HSA receipts yet,{' '}
                    <a
                        className="underline"
                        href={learnMoreUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Click here
                    </a>{' '}
                    to learn more or upload new receipts.
                </p>
            </div>
            <Graph data={data} noReciepts={true} data-testid={'NoExpenseComponent-Graph'} />
        </>
    )
}
